export default {
  CATEGORY_SELECT_PATH: 'categorySelect',

  RECIPE_SELECT_PATH: 'recipeSelect',

  BLOG_SELECT_PATH: 'blogSelect',

  PRODUCT_SELECT_PATH: 'productSelect',

  USER_SELECT_PATH: 'userSelect'
}